

export function transformImage(image, resolution, quality) {
    if (!image) return "";
    if (!resolution) return "";
    if (!quality) return "100";
    let imageService = "https://img2.storyblok.com";
    let path = image.replace("https://a.storyblok.com", "");
    return `${imageService}/${resolution}/filters:quality(${quality})/${path}`;
}